import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=6bc8ffc4&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports